import { SearchOutlined } from '@ant-design/icons';
import { useSelector } from '@redux';
import { Button } from 'antd';
import { DynamicObjectType } from 'core/types/common';
import CreateButton from 'layout/PrivateLayout/CreateButton';
import SearchInput from 'layout/PrivateLayout/SearchInput';
import { HeaderWrapper } from 'layout/PrivateLayout/styles';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { newCheckRole } from 'utils/tools';

export type HeaderProps = {
  title?: string;
  customCreateBtn?: React.ReactNode;
  isCreateModal?: boolean;
  customRootPath?: string;
  hiddenCreateButton?: boolean;
  checkRoles?: DynamicObjectType;
};

export default function Header({
  title,
  isCreateModal,
  customCreateBtn,
  customRootPath,
  hiddenCreateButton,
  checkRoles,
}: HeaderProps) {
  const user = useSelector<DynamicObjectType>((state) => state.auth.data);

  const { t } = useTranslation();
  const [isShowSearch, setShowSearch] = useState(false);
  // const paths = window.location.pathname;
  // const { id } = useParams();

  // const ignoreButton = [
  //   '/products/settings',
  //   '/products/settings/brands/create',
  //   `/products/settings/brands/${id}/edit`,
  //   '/products/create',
  // ];
  const hasButtonCreate = useMemo(
    () =>
      !hiddenCreateButton &&
      newCheckRole(
        checkRoles?.endpoint,
        'POST',
        user?.roles,
        user?.isSuperUser,
      ),
    [user, checkRoles, hiddenCreateButton],
  );

  return (
    <HeaderWrapper>
      <div className="main-header">
        <div className="page-title">{t(title)}</div>
        {/* <div className="search-bar d-desktop">
          <SearchInput defaultValue="" />
        </div> */}
        <div className="btn-create">
          <div className="d-flex flex-center">
            <div className="search-bar d-mobile">
              <Button
                onClick={() => setShowSearch((o) => !o)}
                type="text"
                icon={<SearchOutlined />}
              />
            </div>
            {hasButtonCreate && (
              <>
                {customCreateBtn || (
                  <CreateButton
                    isCreateModal={isCreateModal}
                    customRootPath={customRootPath}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {isShowSearch && (
        <div className="search-bar-mobile d-mobile">
          <SearchInput defaultValue="" />
        </div>
      )}
    </HeaderWrapper>
  );
}
